import { Injectable } from '@angular/core';
import { IProgram, IRetailer } from '@app/shared/interfaces/retailers.interface';
import { HttpService } from '@app/shared/services/http/http.service';
import { UrlService } from '@app/shared/services/url/url.service';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RetailersService {
  constructor(private _httpService: HttpService, private _urlService: UrlService) {}

  createRetailer(newRetailer: IRetailer): Observable<any> {
    const url = this._urlService.getUrl('COLLECT_TVF.addRetailer');

    return this._httpService
      .post(url, newRetailer)
      .pipe(catchError((error: any) => throwError(error)));
  }

  getRetailers(page: number, pageSize: number, searchField: string): Observable<any> {
    const url = this._urlService.getUrl('COLLECT_TVF.getRetailerList', {
      page,
      pageSize,
      searchField,
    });

    return this._httpService.get(url, {}).pipe(catchError((error: any) => throwError(error)));
  }

  updateRetailer(newRetailerData: IRetailer, retailerCurrentId: string): Observable<any> {
    const url = this._urlService.getUrl('COLLECT_TVF.updateRetailer', { retailerCurrentId });
    const { retailerId, ...rest } = newRetailerData;

    return this._httpService
      .put(url, { newRetailerId: newRetailerData.retailerId, ...rest })
      .pipe(catchError((error: any) => throwError(error)));
  }

  deleteRetailer(retailerId: string): Observable<any> {
    const url = this._urlService.getUrl('COLLECT_TVF.deleteRetailer', { retailerId });

    return this._httpService.delete(url, {}).pipe(catchError((error: any) => throwError(error)));
  }

  getPrograms(): Observable<IProgram[]> {
    const url = this._urlService.getUrl('COLLECT_TVF.getPrograms');

    return this._httpService
      .get(url, {})
      .pipe(catchError((error: any) => throwError(error)));
  }
}
